import React from 'react';
import cn from '@/utils/cn';
import csrfToken from '../../shared/adminCsrf';

interface PostLinkProps {
  children: React.ReactNode;
  className?: string;
  href: string;
}

// A legacy "Create" link (a rails-ujs POST that lands on the new record's page), as a form so it
// works on both mounts without rails-ujs.
const PostLink = ({ children, className, href }: PostLinkProps) => (
  <form action={href} className="tw-inline" method="post">
    <input name="authenticity_token" type="hidden" value={csrfToken()} />
    <button
      className={cn('tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0 tw-text-sm', className)}
      type="submit"
    >
      {children}
    </button>
  </form>
);

export default PostLink;
